import { combineLatest, Observable, switchMap, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { OccEndpointsService, UserIdService } from '@spartacus/core';
import { ActiveCartService } from '@spartacus/cart/base/core';

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  constructor(
    private readonly userIdService: UserIdService,
    private readonly activeCartService: ActiveCartService,
    private readonly occEndpointsService: OccEndpointsService,
    private readonly http: HttpClient
  ) {}

  claimCoupon(couponId: string): Observable<Record<string, any>> {
    return combineLatest([this.userIdService.takeUserId(false), this.activeCartService.getActiveCartId()]).pipe(
      take(1),
      switchMap(([userId, cartId]) => {
        const url: string = this.occEndpointsService.buildUrl('coupon', { urlParams: { userId, cartId, couponId } });
        return this.http.post(url, {});
      })
    );
  }

  deleteCoupon(couponId: string): Observable<Record<string, any>> {
    return combineLatest([this.userIdService.takeUserId(false), this.activeCartService.getActiveCartId()]).pipe(
      take(1),
      switchMap(([userId, cartId]) => {
        const url: string = this.occEndpointsService.buildUrl('coupon', { urlParams: { userId, cartId, couponId } });
        return this.http.delete(url);
      })
    );
  }
}
